import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../core/services/base-api.service';
import { PageResult } from '../../shared/models/page-result.model';
import { Library } from '../../types/library';

@Injectable({
  providedIn: 'root',
})
export class LibrariesService extends BaseApiService {
  protected override basePath = '/api';

  getLibraries(page: number, pageSize: number): Observable<PageResult<Library>> {
    let params = new HttpParams()
      .set('CurrentPage', page.toString())
      .set('PageSize', pageSize.toString());

    return this.get<PageResult<Library>>('/Library', params);
  }
}
